import { useState } from "react";
import { Aspiration } from "./Aspiration";
import { Clusters } from "./Clusters";
import { loadEnglishDictionaries } from "../../loader/loadEnglishDictionaries";
import { Prevowel } from "./Prevowel";
import { Palatalization } from "./Palatalization";
import { Diphthongs } from "./Diphthongs";
import { Clicks } from "./Clicks";
import { Syllabics } from "./Syllabic";
import { Approximants } from "./Approximants";
import { Affricates } from "./Affricates";
import { Chinese } from "./Chinese";
import { EncodeCore } from "./EncodeCore";
import { Nasals } from "./Nasals";

/** testing various aspects of driving the speech synthesizer */
export function Testing() {
  const [init, setInit] = useState(false);
  if (!init) {
    setInit(true);
    loadEnglishDictionaries();
  }

  return (<div className='page'>
    <ul>
      <li><a href="#nasals">nasals</a></li>
      <li><a href="#clusters">consonant clusters</a></li>
      <li><a href="#prevowel">prevowel</a></li>
      <li><a href="#diphthongs">diphthongs</a></li>
      <li><a href="#aspiration">aspiration</a></li>
      <li><a href="#palatalization">palatalization</a></li>
      <li><a href="#clicks">clicks</a></li>
      <li><a href="#syllabics">syllabics</a></li>
      <li><a href="#approximants">approximants</a></li>
      <li><a href="#affricates">affricates and co-articulated consonants</a></li>
      <li><a href="#chinese">chinese</a></li>
    </ul>

    <span id="encodeCore" /><EncodeCore />
    <span id="nasals" /><Nasals />
    <span id="clusters" /><Clusters />
    <span id="prevowel" /><Prevowel />
    <span id="diphthongs" /><Diphthongs />
    <span id="aspiration" /><Aspiration />
    <span id="palatalization" /><Palatalization />
    <span id="clicks" /><Clicks />
    <span id="syllabics" /><Syllabics />
    <span id="approximants" /><Approximants />
    <span id="affricates" /><Affricates />
    <span id="chinese" /><Chinese />
  </div>)
}
